import { useState, useEffect } from 'react';
import { SwitchProps, Switch, FormControlLabel } from '@mui/material';

type TVSwitchdProps = SwitchProps & {
  name: string;
  label: string;
  fdisabled: boolean;
  aliamento: 'end' | 'start' | 'top' | 'bottom';
  valor?: (novoTextoselect: boolean | undefined) => void;
  initialValue?: boolean; // Valor inicial externo
};

export const VSwitch02: React.FC<TVSwitchdProps> = ({
  valor,
  name,
  fdisabled,
  label,
  aliamento,
  initialValue = false, // Valor inicial padrão
}) => {
  const [checked, setChecked] = useState(initialValue);

  // Sincroniza o estado interno com o valor inicial sempre que ele muda
  useEffect(() => {
    setChecked(initialValue);
  }, [initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked;
    setChecked(newChecked); // Atualiza o estado interno
    valor?.(newChecked); // Notifica o componente pai
  };

  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={checked}
          onChange={handleChange}
          color="primary"
          disabled={fdisabled}
        />
      }
      label={label}
      labelPlacement={aliamento}
    />
  );
};
